import * as React from 'react';
import { memo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { PATHS } from 'router/config';
import { Heading } from 'atoms';
import { MainTemplate } from 'templates';

import { ZoomTabs } from './ZoomTabs';
import { Dashboard } from './Dashboard';
import { LessonsList, LessonCard } from './Lessons';
import { RecordingsList, RecordingCard } from './Recordings';
import { Matching } from './Matching';
import { RecentList } from './Recent';
import { Accounts } from './Accounts';
import { Schedule } from './Schedule';
import { Audit } from './Audit';

export const ZoomRecordings = memo(() => {
  const { t } = useTranslation();

  return (
    <MainTemplate>
      <Wrapper>
        <HeadingWrapper>
          <Heading>{t('pages.zoom.title')}</Heading>
        </HeadingWrapper>
        <ZoomTabs />
        <Content>
          <Switch>
            <Route exact path={PATHS.zoom}>
              <Redirect to={PATHS.zoomDashboard} />
            </Route>
            <Route path={PATHS.zoomDashboard} component={Dashboard} />
            <Route path={PATHS.zoomMatching} component={Matching} />
            <Route path={PATHS.zoomLesson} component={LessonCard} />
            <Route path={PATHS.zoomLessons} component={LessonsList} />
            <Route path={PATHS.zoomRecording} component={RecordingCard} />
            <Route path={PATHS.zoomRecordings} component={RecordingsList} />
            <Route path={PATHS.zoomRecent} component={RecentList} />
            <Route path={PATHS.zoomAccounts} component={Accounts} />
            <Route path={PATHS.zoomSchedule} component={Schedule} />
            <Route path={PATHS.zoomAudit} component={Audit} />
            <Route>
              <Redirect to={PATHS.zoomDashboard} />
            </Route>
          </Switch>
        </Content>
      </Wrapper>
    </MainTemplate>
  );
});

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const HeadingWrapper = styled.div`
  margin-top: 48px;
`;

const Content = styled.div`
  width: 100%;
  margin-top: 8px;
`;
